import { useQuery } from '@tanstack/react-query'
import { getOpportunityTasks } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunityTasksOptions {
  taskStatusId?: number
  memberId?: number
}

/**
 * オポチュニティのタスク一覧取得フック（詳細画面用）
 */
export function useOpportunityTasks(opportunityId: number, options: UseOpportunityTasksOptions = {}) {
  const { taskStatusId, memberId } = options

  return useQuery({
    queryKey: queryKeys.opportunity.tasksList(opportunityId, { taskStatusId, memberId }),
    queryFn: async () => {
      return getOpportunityTasks(opportunityId, { taskStatusId, memberId })
    },
    enabled: !!opportunityId,
  })
}
